<template>
  <div class="faq-answer" v-html="html" @click="onClick" />
</template>

<script>
import MarkdownIt from 'markdown-it'

// html: false — FAQ content is static and bundled, but keep raw HTML out anyway.
const md = new MarkdownIt({ html: false, linkify: true })

export default {
  name: 'FaqAnswer',
  props: { source: { type: String, required: true } },
  computed: {
    html() {
      return md.render(this.source)
    },
  },
  methods: {
    /** Route in-app links (href starting with "/") through the router instead of reloading. */
    onClick(e) {
      const a = e.target.closest('a')
      const href = a && a.getAttribute('href')
      if (href && href.startsWith('/')) {
        e.preventDefault()
        this.$router.push(href)
      }
    },
  },
}
</script>

<style scoped>
.faq-answer ::v-deep p,
.faq-answer ::v-deep ol,
.faq-answer ::v-deep ul {
  margin-bottom: 12px;
  line-height: 1.6;
}
</style>
